import { useQuery } from "react-query"
import { fetchGET, fetchGET2 } from "utils/https/https"
import { useTranslation } from '../../utils/translation/Translation';


const useQueryCatalogType = () => {
  const translate = useTranslation()
  return useQuery(['UseQueryCatalogType'], async () => {

    try {
      const response = await fetchGET('Catalog/GetCatalog/type')
      const newData = response?.data.map((item: {id: string, name: string}) => ({
        label: translate(item.name),
        value: item.id
      }))
      return newData
      
    } catch (error) {
      throw error
      
    }

  })

}

const useQueryCatalogCommissionType = () => {
  const translate = useTranslation()
  return useQuery(['useQueryCatalogCommissionType'], async () => {

    try {
      const response = await fetchGET('Catalog/GetCatalog/CommissionType')
      const newData = response?.data.map((item: {id: string, name: string}) => ({
        label: item.name,
        value: item.id
      }))
      return newData
      
    } catch (error) {
      throw error
      
    }

  })

}

const useQueryCatalogCommissionDescription = () => {
  const translate = useTranslation()
  return useQuery(['useQueryCatalogCommissionDescription'], async () => {

    try {
      const response = await fetchGET('Catalog/GetCatalog/CommissionDescription')
      const newData = response?.data.map((item: {id: string, name: string}) => ({
        label: item.name,
        value: item.id
      }))
      return newData
      
    } catch (error) {
      throw error
      
    }

  })

}

export const useQueryCatalogCommissionSystemManagementType = () => {
  return useQuery(['useQueryCatalogCommissionManagementType'], async () => {

    try {

    const response = await fetchGET2('Catalog/GetCatalog/CommissionManagementType')
    const newData = response.data.map((item: any) => ({
      label: item.name,
      value: item.id,
    }))

    return newData || []
      
    } catch (error) {
      throw error
    }

  })
}





export const useQueryCatalogCommissionSystem = {
  useQueryCatalogType,
  useQueryCatalogCommissionType,
  useQueryCatalogCommissionDescription,
  useQueryCatalogCommissionSystemManagementType,
}
